<script>
import Emr from '@/components/Emr/Emr.vue'
export default Emr
</script>
